<template>
  <div class="chat-messages" ref="messageList" @scroll="handleScroll">
    <div v-if="isLoading" class="loading-more">
      <i class="el-icon-loading"></i>
      <span>加载中...</span>
    </div>
    <div class="message-container">
      <div class="msg-list__item" v-for="msg in messages" :key="msg.ID">
        <!-- 时间分隔符 -->
        <div class="time-divider" v-if="msg.isTimeDivider && msg.time">
          {{ parseTime(msg.time, "YYYY-MM-DD HH:mm") }}
        </div>
        <message-system
          v-else-if="showMessageSystem(msg)"
          :showContext="msg.showContext"
          :message="msg"
        ></message-system>
        <message-bubble
          v-else-if="!msg.isTimeDivider && msg.type !== 'system'"
          :message="msg"
          :type="type"
          :currentSession="currentSession"
          @resendMessage="resendMessage"
        >
          <div @contextmenu.prevent="(e) => showContextMenu(e, msg)">
            <message-text
              v-if="msg.type === 'text'"
              :data="msg.showContext || ''"
            />
            <message-image
              v-else-if="msg.type === 'image'"
              :data="msg.showContext"
            ></message-image>
            <message-file
              v-else-if="msg.type === 'file'"
              :showContext="msg.showContext"
              :message="msg"
            ></message-file>
            <div v-else class="message-component">
              {{ "该内容无法进行展示，需更新版本后，才可查看" }}
            </div>
          </div>
        </message-bubble>
      </div>

      <!-- 引入右键菜单组件 -->
      <message-context-menu
        ref="contextMenu"
        :menu-items="showMenuItems"
        :position="menuPosition"
        @menu-click="handleMenuClick"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import formatTime from "@saas/components/src/utils/filters.js";
import { EventBus } from "@saas/components/src/utils/event-bus";
import MessageContextMenu from "../message-components/MessageContextMenu";
import MessageBubble from "../message-components/MessageBubble";
import MessageText from "../message-components/MessageText";
import MessageImage from "../message-components/MessageImage";
import MessageFile from "../message-components/MessageFile";
import MessageSystem from "../message-components/MessageSystem";

export default {
  name: "MsgList",
  components: {
    MessageBubble,
    MessageText,
    MessageImage,
    MessageFile,
    MessageSystem,
    MessageContextMenu,
  },
  props: {
    messages: Array,
    type: {
      type: String,
      default: "group",
    },
    currentSession: {
      type: Object,
      default: () => ({}),
    },
  },
  data: function () {
    return {
      menuPosition: {
        x: 0,
        y: 0,
      },
      menuItems: [
        { text: "引用", value: "replay" },
        {
          text: "撤回",
          value: "withdraw",
        },
      ], // 菜单项
      showMenuItems: [], // 展示的菜单项
      currentMessage: null,
      isLoading: false, // 是否正在加载更多消息
      isScrollToBottom: false, // 是否正在滚动到底部
      parseTime: formatTime.formatSelfTime,
    };
  },
  created() {
    EventBus.$off("live-chat-scroll-to-bottom");
    EventBus.$on("live-chat-scroll-to-bottom", () => {
      // 如果正在加载历史消息，不执行滚动到底部
      if (this.isLoading) {
        return;
      }
      this.isScrollToBottom = true;
      this.scrollToBottom();
    });
  },
  mounted() {
    window.ipcRenderer?.on(
      "file-download-progress",
      this.handleFileDownloadProgress
    );
    window.ipcRenderer?.on("file-download-done", this.fileDownLoadDone);
    window.ipcRenderer?.on("open-file-err", this.handleOpenFileError);
  },
  beforeDestroy() {
    window.ipcRenderer?.removeListener(
      "file-download-progress",
      this.handleFileDownloadProgress
    );
    window.ipcRenderer?.removeListener(
      "file-download-done",
      this.fileDownLoadDone
    );
    window.ipcRenderer?.removeListener(
      "open-file-err",
      this.handleOpenFileError
    );
    EventBus.$off("live-chat-scroll-to-bottom");
  },
  methods: {
    ...mapMutations("newChat", [
      "SET_REPLAY_MESSAGE",
      "SET_DOWNLOAD_INFO",
      "DELETE_DOWNLOAD_INFO",
      "SET_DOWNLOADED_FILE_LIST",
      "UPDATE_DOWNLOADED_FILE_LIST",
    ]),
    ...mapActions("newChat", ["handleIpcEvent"]),
    resendMessage(message) {
      this.$emit("resendMessage", message);
    },
    handleOpenFileError(event, data) {
      this.SET_DOWNLOADED_FILE_LIST(
        this.downloadedFileList.filter((item) => item !== data.file_name)
      );
      if (this.chatMode === "popup" && window.ipcRenderer) {
        window.ipcRenderer.send("chat-state-update", {
          type: "open-file-err",
          downloadedFileList: this.downloadedFileList,
          errorMessage: data.message,
        });
      } else {
        this.$darkMessage.error(data.message);
      }
    },
    fileDownLoadDone(event, data) {
      console.log("==zy==file-download-done", data);
      let message = "";
      if (data.cancelled) {
        // 取消下载
        this.DELETE_DOWNLOAD_INFO(data.im_msg_key);
      } else if (!data.completed) {
        message = window?.navigator?.onLine
          ? "下载失败"
          : "暂无网络，无法进行下载";
        this.SET_DOWNLOAD_INFO({
          [data.im_msg_key]: {
            ...data,
            cancelled: true,
          },
        });
      } else if (data.completed) {
        // 下载完成
        this.UPDATE_DOWNLOADED_FILE_LIST([data.file_name]);
        this.DELETE_DOWNLOAD_INFO(data.im_msg_key);
      }
      if (this.chatMode === "popup" && window.ipcRenderer) {
        window.ipcRenderer.send("chat-state-update", {
          type: "file-download-done",
          downloadInfo: this.downloadInfo,
          downloadedFileList: this.downloadedFileList,
          errorMessage: message,
        });
      } else {
        if (message) {
          this.$darkMessage.error(message);
        }
      }
    },
    handleFileDownloadProgress(event, data) {
      const { im_msg_key } = data;
      console.log("==zy==file-download-progress", {
        [im_msg_key]: { ...data },
      });
      this.SET_DOWNLOAD_INFO({
        [im_msg_key]: { ...data },
      });
      if (this.chatMode === "popup" && window.ipcRenderer) {
        window.ipcRenderer.send("chat-state-update", {
          type: "file-download-progress",
          downloadInfo: this.downloadInfo,
        });
      }
    },

    // 处理滚动事件，检测是否需要加载更多历史消息
    async handleScroll(e) {
      // 如果正在加载或已经没有更多消息或消息列表为空，直接返回
      if (
        this.isLoading ||
        !this.hasMoreMessages ||
        this.messages.length === 0 ||
        this.isScrollToBottom
      ) {
        return;
      }

      const messageList = this.$refs.messageList;
      if (!messageList) return;

      const { scrollTop } = messageList;
      // 当scrollTop接近0时，表示用户滚动到了顶部（历史消息区域）
      // 当滚动到顶部附近时加载更多消息
      if (scrollTop < 100) {
        // 设置加载状态，防止重复请求
        this.isLoading = true;

        try {
          // 记录当前滚动位置，用于在添加历史消息后保持位置
          const scrollHeightBefore = messageList.scrollHeight;

          // 定义回调函数
          const callback = (hasMore) => {
            console.log("==zy==hasMore callback", hasMore);
            this.isLoading = false;

            // 在下一个tick中恢复滚动位置
            this.$nextTick(() => {
              if (messageList) {
                const scrollHeightAfter = messageList.scrollHeight;
                const scrollTop = scrollHeightAfter - scrollHeightBefore;
                messageList.scrollTop = scrollTop;
              }
            });
          };
          // 发送加载更多消息事件，传递参数对象和回调函数
          this.$emit("load-more-messages", {}, callback);
        } catch (error) {
          console.error("==zy==加载历史消息失败:", error);
          this.isLoading = false;
        }
      }
    },

    showContextMenu(event, msg) {
      const { flow, type } = msg;
      // 自己未发送成功的消息，不显示菜单
      if (msg.flow === "out" && msg.status !== "success") {
        return;
      }
      // 拷贝一份菜单项
      this.showMenuItems = [...this.menuItems];
      if (window.isElectron && flow === "in" && type === "file") {
        if (this.downloadedFileList.includes(msg.showContext.name)) {
          // 已下载
          // 没有的话，添加打开和打开文件夹
          if (!this.showMenuItems.find((item) => item.value === "openFile")) {
            this.showMenuItems.push({ text: "打开", value: "openFile" });
          }
          if (!this.showMenuItems.find((item) => item.value === "openFolder")) {
            this.showMenuItems.push({
              text: "打开文件夹",
              value: "openFolder",
            });
          }
        }
      }
      if (this.isShutUp) {
        // 禁言-删除撤回、引用
        this.showMenuItems = this.showMenuItems.filter(
          (item) => !["replay", "withdraw"].includes(item.value)
        );
      }
      if (this.showMenuItems?.length === 0) {
        return;
      }
      this.dealWithdrawStatus(msg);
      // 更新菜单位置
      this.menuPosition = {
        x: event.clientX,
        y: event.clientY,
      };

      // 显示菜单
      this.$refs.contextMenu.show(this.menuPosition);
      this.currentMessage = msg;
    },
    handleMenuClick(item) {
      const { value } = item;
      if (value === "replay") {
        this.SET_REPLAY_MESSAGE(this.currentMessage);
      } else if (["openFile", "openFolder"].includes(value)) {
        if (window?.LiveElectronApi?.openOrDownloadFile) {
          const { file_id, name, date } = this.currentMessage.showContext;
          const params = {
            file_id,
            file_path: this.defaultDownloadPath + name,
            date,
            file_name: name,
            im_msg_key: this.currentMessage.ID,
            openType: value === "openFile" ? 1 : 2,
            winKey: "custom-live-room",
          };
          window.LiveElectronApi.openOrDownloadFile(params);
          console.log("==zy==openFolder", params);
        }
      } else if (value === "withdraw") {
        // 撤回
        const message = {
          ...this.currentMessage,
          type: "system",
          systemType: "revoked",
          isSelf: true,
        };
        if (this.chatMode === "popup" && window.ipcRenderer) {
          this.handleIpcEvent({
            type: "message-update",
            payload: {
              message: message,
            },
          });
          window.ipcRenderer.send("chat-event-from-popup", {
            type: "revoked-message",
            data: message,
          });
          if (this.replayMessage) {
            const isReply = this.replayMessage.ID === this.currentMessage.ID;
            if (isReply) {
              this.SET_REPLAY_MESSAGE(null);
            }
          }
        } else {
          this.imService
            .revokeMessage(this.currentMessage)
            .then((res) => {
              this.handleIpcEvent({
                type: "message-update",
                payload: {
                  message: message,
                },
              });
              if (this.replayMessage) {
                const isReply =
                  this.replayMessage.ID === this.currentMessage.ID;
                if (isReply) {
                  this.SET_REPLAY_MESSAGE(null);
                }
              }
              console.log("live_撤回消息", res);
            })
            .catch((err) => {
              console.log("live_撤回消息失败", err);
            });
        }
        console.log("live_this.cureentMessage", this.currentMessage);
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        // TODO 当时为什么加延时
        // setTimeout(() => {
        if (this.$refs.messageList) {
          const messageList = this.$refs.messageList;
          messageList.scrollTop = messageList.scrollHeight;
        }
        this.isScrollToBottom = false;
        // }, 100);
      });
    },
    // 处理撤回按钮展示状态
    dealWithdrawStatus(msg) {
      // 判断是否为老师或助教
      const isTeacherOrAssistant =
        this.userInfo?.isTeacher || this.userInfo?.isAssistant;

      // 判断是否为自己发送的消息
      const isSelf = msg.from === this.userInfo.user_id;

      // 消息时间戳（秒转毫秒）
      const msgTime = Number(msg.time) * 1000;
      const now = Date.now();

      // 撤回时限
      const withdrawLimit = isTeacherOrAssistant
        ? 7 * 24 * 60 * 60 * 1000 // 7天
        : 2 * 60 * 1000; // 2分钟

      const canWithdraw = isSelf && now - msgTime <= withdrawLimit;

      if (canWithdraw) {
        // 添加撤回项（如不存在）
        if (!this.showMenuItems.find((item) => item.value === "withdraw")) {
          this.showMenuItems.push({ text: "撤回", value: "withdraw" });
        }
      } else {
        // 移除撤回项
        this.showMenuItems = this.showMenuItems.filter(
          (item) => item.value !== "withdraw"
        );
      }
    },
    showMessageSystem(msg) {
      if (msg.type === "system") {
        if (this.type === "group") {
          return true;
        } else {
          if (msg.systemType === "revoked") {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },
  },
  computed: {
    ...mapState("newChat", [
      "hasMoreMessages",
      "downloadedFileList",
      "defaultDownloadPath",
      "chatMode",
      "downloadInfo",
      "userInfo",
      "replayMessage",
    ]),
    ...mapState("live", ["imService"]),
    ...mapGetters("live", ["isShutUp"]),
  },
};
</script>
<style lang="scss" scoped>
.chat-messages {
  height: 100%;
  overflow-y: auto;
  padding: 10px;
  display: flex;
  flex-direction: column; /* 改为正常的从上到下排列 */

  /* 滚动条样式 - 修复抖动问题 */
  overflow-x: hidden;

  /* 始终保留滚动条的空间，避免显示/隐藏时的抖动 */
  padding-right: 4px; /* 为滚动条预留空间 */
  box-sizing: border-box;

  /* 默认滚动条透明 */
  &::-webkit-scrollbar {
    width: 4px; /* 保持宽度一致，避免抖动 */
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent; /* 默认透明 */
    border-radius: 4px;
    transition: background-color 0.3s; /* 平滑过渡效果 */
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      background-color: #27272a; /* 鼠标悬停时显示滚动条颜色 */
    }
  }

  /* Firefox 滚动条样式 */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent; /* 默认透明 */

  &:hover {
    scrollbar-color: #27272a transparent; /* 悬停时显示颜色 */
  }

  //时间分割线
  .time-divider {
    font-weight: 400;
    font-size: 12px;
    color: #86909c;
    line-height: 20px;
    text-align: center;
    margin-bottom: 16px;
  }
}

.message-container {
  display: flex;
  flex-direction: column; /* 内部容器正向排列，保持消息顺序 */
  width: 100%; /* 确保内容宽度一致 */
}

.loading-more {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  color: #909399;
  font-size: 12px;

  i {
    margin-right: 5px;
  }
}
</style>
